<template>
    <div class="paging" v-if="pageList.length > 1">
        <span v-for="page in pageList" :key="page">
            <template v-if="page == 0">
                <button class="item skip">
                    ...
                </button>
            </template>
            <template v-else>
                <button class="item" :class="page == activePage ? 'active' : ''" @click="changePage(page)">
                    {{ page }}
                </button>
            </template>
        </span>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pageList: [],
            totalPage: 0
        }
    },
    props: {
        activePage:  {
            type: Number,
            required: true
        },
        pageSize: {
            type: Number,
            required: true
        },
        contentLength: {
            type: Number,
            required: true
        }
    },
    watch: {
        activePage(value) {
            this.setupPageList(value)
        },
        contentLength(value) {
            this.calculateTotalPage(value);
            this.setupPageList();
        }
    },
    methods: {
        setupPageList() {
            let isSkip = false;
            const size = 2;
            this.pageList = [];

            for (let page = 1; page <= this.totalPage; page++) {
                if (page == 1 || page == this.totalPage || page == this.activePage || ((this.activePage - page) <= size && (page - this.activePage) <= size)) {
                    isSkip = false;
                    this.pageList.push(page);
                }
                else {
                    if (!isSkip) {
                        isSkip = true;
                        this.pageList.push(0);
                    }
                }
            }
        },
        calculateTotalPage(contentLength) {
            const totalPage = Math.ceil(contentLength / this.pageSize);

            if (totalPage === 1) {
                this.totalPage = 0;
            } else {
                this.totalPage = totalPage;
            }
        },
        changePage(page) {
            this.$emit('page', page);
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.paging {
    overflow: hidden;
    text-align: center;
    
    .item {
        display: inline-block;
        margin: 0 10px;
        padding: 2px 8px;
        font-size: 14px;
        background: none;
        border: 1px solid $pagingBorderColor;
        outline: none;
        color: $textMainColor;

        &.active {
            background: $mainColor;
            color: $pagingBorderColor;
        }

        &.skip {
            cursor: default;
            border: 1px solid transparent;
        }
    }
}
</style>